import styled from "styled-components"
import {Row} from "react-bootstrap"

import Button from "../../Button"

export const RowRelative = styled(Row)`
  position: relative;
`

export const AddButton = styled(Button)`
  margin: 20px 0;
`

export const RemoveButton = styled(Button)`
  position: absolute;
  right: 17px;
  top: 29px;
  padding: 13px 20px;
  &:focus,
  &:active {
    padding: 13px 20px;
  }
`
